import SurveyHistory from "components/survey/SurveyHistory";
import {
  DASHBOARD_PATH,
  LOGIN_PATH,
  Leadcaremanager_PATH,
  Members_PATH,
  OutreachLeaders_PATH,
  OutreachStaff_PATH,
  POLICIES_PATH,
  COMMUNITY_OUTREACH_PATH,
  QUESTIONS_PATH,
  RELEASE_PATH,
  RESET_PASSWORD_PATH,
  SURVEY_HISTORIES_PATH,
  SURVEY_HISTORY_PATH,
  SURVEY_PATH,
  START_ENCOUNTERS_PATH,
  ENCOUNTERS_HISTORY_PATH,
  REFERRALS_PATH,
  REFERRAL_HISTORY_PATH,
  USERS_PATH,
  TEMPLATES_PATH,
  ReferralCoordinator_PATH,
  SPA_PATH,
} from "constants/routePaths";
import Dashboard from "containers/dashboard";
import History from "containers/history";
import Leadcaremanager from "containers/leadcaremanager";
import Login from "containers/login";
import Members from "containers/members";
import OutreachLeaders from "containers/outreachleaders";
import OutreachStaff from "containers/outreachstaff";
import ReferralCoordinator from "containers/referralcoordinator";
import CommunityOutreach from "containers/community";
import StartEncounter from "containers/community/StartEncounter";
import Policies from "containers/policies";
import Questions from "containers/questions";
import Releases from "containers/releases";
import Reset from "containers/reset-password";
import Survey from "containers/survey";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Protected from "routes/Protected";
import EncounterHistory from "containers/community/EncounterHistory";
import Referrals from "containers/referrals";
import ShowReferral from "containers/referrals/show";
import Users from "containers/users";
import Templates from "containers/templates/index";
import Spa from "containers/spa";

const AppRoutes = ({ isLoggedIn }) => {
  return (
    <Routes>
      {/* Guest Routes */}
      <Route path={LOGIN_PATH} element={<Login />} />
      <Route path={RESET_PASSWORD_PATH} element={<Reset />} />

      {/* Protected Routes */}
      <Route
        path={DASHBOARD_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Dashboard />
          </Protected>
        }
      />
      <Route
        path={QUESTIONS_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Questions />
          </Protected>
        }
      />
      <Route
        path={Leadcaremanager_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Leadcaremanager />
          </Protected>
        }
      />
      {/* <Route
        path={OutreachLeaders_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <OutreachLeaders />
          </Protected>
        }
      /> */}
      <Route
        path={OutreachStaff_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <OutreachStaff />
          </Protected>
        }
      />
      <Route
        path={Members_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Members />
          </Protected>
        }
      />
      <Route
        path={POLICIES_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Policies />
          </Protected>
        }
      />
      <Route
        path={COMMUNITY_OUTREACH_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <CommunityOutreach />
          </Protected>
        }
      />
      <Route
        path={SURVEY_HISTORIES_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <History />
          </Protected>
        }
      />
      <Route
        path={START_ENCOUNTERS_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <StartEncounter />
          </Protected>
        }
      />
      <Route
        path={ENCOUNTERS_HISTORY_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <EncounterHistory />
          </Protected>
        }
      />
      <Route
        path={SURVEY_HISTORY_PATH}
        element={
          <Protected visibleSidebar={false} isLoggedIn={isLoggedIn}>
            <SurveyHistory />
          </Protected>
        }
      />
      <Route
        path={REFERRAL_HISTORY_PATH}
        element={
          <Protected visibleSidebar={false} isLoggedIn={isLoggedIn}>
            <SurveyHistory />
          </Protected>
        }
      />
      <Route
        path={SURVEY_PATH}
        element={
          <Protected
            visibleSidebar={false}
            showSurveyHeader={true}
            isLoggedIn={isLoggedIn}
          >
            <Survey />
          </Protected>
        }
      />
      <Route
        path={RELEASE_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Releases />
          </Protected>
        }
      />
      <Route
        path={REFERRALS_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Referrals />
          </Protected>
        }
      />
      <Route
        path={USERS_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Users />
          </Protected>
        }
      />
      <Route
        path={TEMPLATES_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Templates />
          </Protected>
        }
      />
      <Route
        path={ReferralCoordinator_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <ReferralCoordinator />
          </Protected>
        }
      />
      <Route
        path={SPA_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <Spa />
          </Protected>
        }
      />
      {/* <Route
        path={REFERRAL_HISTORY_PATH}
        element={
          <Protected isLoggedIn={isLoggedIn}>
            <ShowReferral />
          </Protected>
        }
      /> */}
    </Routes>
  );
};
export default AppRoutes;
